export default "__VITE_ASSET__DMsdfKex__"